import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';
import axios from 'axios';
import config from '../../config';

const PDFDownloadButton = ({ 
  documentType, // 'purchase-order', 'sales-order', 'dispatch-note'
  documentId,
  documentNumber,
  variant = 'primary',
  size = 'sm',
  className = '',
  showIcon = true,
  label = 'Download PDF'
}) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  const getApiEndpoint = () => {
    switch (documentType) {
      case 'purchase-order':
        return `/purchase-orders/${documentId}/download-pdf`;
      case 'sales-order':
        return `/sales-orders/${documentId}/download-pdf`;
      case 'dispatch-note':
        return `/dispatch-notes/${documentId}/download-pdf`;
      default:
        throw new Error('Invalid document type');
    }
  };

  const getFileName = () => {
    const prefix = documentType.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join('_');
    return `${prefix}_${documentNumber || documentId}.pdf`;
  };

  const handleDownload = async () => {
    setDownloading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const endpoint = getApiEndpoint();
      
      const response = await axios.get(`${config.API_BASE_URL}${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        responseType: 'blob' // Important for binary data
      });

      // Create a blob from the PDF data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = getFileName();
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (err) {
      console.error('Error downloading PDF:', err);
      setError(err.response?.data?.message || 'Failed to download PDF');
      
      // Show error for 3 seconds
      setTimeout(() => setError(''), 3000);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={handleDownload}
        disabled={downloading}
        title={label}
      >
        {downloading ? (
          <>
            <Spinner animation="border" size="sm" className="me-1" />
            Downloading...
          </>
        ) : (
          <>
            {showIcon && <FaFilePdf className="me-1" />}
            {label}
          </>
        )}
      </Button>
      {error && (
        <small className="text-danger d-block mt-1">{error}</small>
      )}
    </>
  );
};

export default PDFDownloadButton;
